import { useEffect, useState } from "react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { NotificationBell } from "@/components/notifications";
import { useUser } from "@/contexts/UserContext";
import { UserRole } from "@/shared/constants";

interface HeaderProps {
  title?: string;
  description?: string;
}

export const Header = ({ title, description }: HeaderProps) => {
  const [scrolled, setScrolled] = useState(false);
  const { user } = useUser();
  const isAdmin = user.roles.includes(UserRole.ADMIN);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 h-16 w-full border-b border-border bg-white/95 backdrop-blur-sm transition-all duration-200 ${
        scrolled ? "shadow-sm" : ""
      }`}
    >
      <div className="flex items-center gap-3 md:gap-4 px-3 md:px-6 h-full">
        <SidebarTrigger className="-ml-1 min-h-[44px] min-w-[44px] text-foreground hover:text-primary transition-colors" />

        {title ? (
          <div className="flex flex-col justify-center flex-1 min-w-0">
            <h1 className="text-base md:text-lg lg:text-xl font-semibold text-foreground truncate">
              {title}
            </h1>
            {description && (
              <p className="text-xs md:text-sm text-muted-foreground mt-0.5 truncate">
                {description}
              </p>
            )}
          </div>
        ) : (
          <div className="flex-1" />
        )}
        {!isAdmin && <NotificationBell />}
      </div>
    </header>
  );
};
